import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Scripts Redux States
import {
  GET_SCRIPTS,
  GET_SCRIPT,
  CREATE_SCRIPT,
  EDIT_SCRIPT,
  DELETE_SCRIPT,
} from "./actionTypes";
import {
  setScripts,
  apiError,
  setScript,
  createScriptSuccess,
  editScriptSuccess,
  deleteScriptSuccess,
} from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";

function* getScripts({ payload: { page, qnt, name, skillId } }) {
  try {
    const response = yield call(
      axios.get,
      `/scripts?${
        (page ? `page=${page}` : "") +
        (qnt ? `&qtd=${qnt}` : "") +
        (name ? `&title=${name}` : "") +
        (skillId ? `skill_id=${skillId}` : "")
      }`
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setScripts(response.data.data, qnt));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! the page you are looking for could not be found";
          }
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* createScript({ payload: { newScriptValues } }) {
  try {
    const response = yield call(
      axios.post,
      `/scripts`,
      newScriptValues
    );
    if (response.status >= 200 || response.status <= 299) {
      let message = response.data.message;
      yield put(createScriptSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* getScript({ payload: { idScript, isForm } }) {
  try {
    const response = yield call(
      axios.get,
      `/scripts?${
        (idScript ? `id=${idScript}` : "") +
        (isForm ? `&form=${isForm}` : "")
      }`,
      {}
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setScript(response.data.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* editScript({
  payload: { idScript, newScriptValues },
}) {
  try {
    const response = yield call(
      axios.patch,
      `/scripts?${
        idScript ? `id=${idScript}` : ""
      }`,
      newScriptValues
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.message
    ) {
      let message = response.data.message;
      yield put(editScriptSuccess(message));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* deleteScript({ payload: { idScript } }) {
  try {
    const response = yield call(
      axios.delete,
      `/scripts${
        idScript ? `?id=${idScript}` : ""
      }`
    );
    if (response.status >= 200 || response.status <= 299) {
      let message = response.data.message ? response.data.message : "";
      yield put(deleteScriptSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
export function* watchScript() {
  yield takeEvery(GET_SCRIPTS, getScripts);
}
export function* watchGetScript() {
  yield takeEvery(GET_SCRIPT, getScript);
}
export function* watchCreateScript() {
  yield takeEvery(CREATE_SCRIPT, createScript);
}
export function* watchEditScript() {
  yield takeEvery(EDIT_SCRIPT, editScript);
}
export function* watchDeleteScript() {
  yield takeEvery(DELETE_SCRIPT, deleteScript);
}
function* authSaga() {
  yield all([
    fork(watchScript),
    fork(watchGetScript),
    fork(watchCreateScript),
    fork(watchEditScript),
    fork(watchDeleteScript),
  ]);
}

export default authSaga;
